import { useProjectsQuery } from '../../../../hooks/contentful';

import SectionHeader2 from '../../../uiParts/SectionHeader2/SectionHeader2';
import Section from '../../../uiParts/Sections/Section/Section';
import ThumbNailMiniLists from '../../../uiParts/ThumbNails/ThumbNailMiniLists/ThumbNailMiniLists';

import styles from './Works.module.css';

export default function Works() {
  const { data } = useProjectsQuery();

  return (
    <Section className={styles.section}>
      <SectionHeader2 text="MY WORKS" mb={60} />
      {data && <ThumbNailMiniLists thumbs={data} />}
    </Section>
  );
}
